import { validator, DEFAULT_FORMATS } from '../utils'
export const PICKER_PROPS = {
  size: String,
  format: String,
  formatter: Function,
  valueFormatter: Function,
  valueFormat: {
    type: String,
    default: DEFAULT_FORMATS.valueFormat
  },
  readonly: Boolean,
  placeholder: String,
  startPlaceholder: String,
  endPlaceholder: String,
  prefixIcon: String,
  clearIcon: {
    type: String,
    default: 'el-icon-circle-close'
  },
  name: {
    default: '',
    validator
  },
  disabled: Boolean,
  clearable: {
    type: Boolean,
    default: true
  },
  id: {
    default: '',
    validator
  },
  popperClass: String,
  editable: {
    type: Boolean,
    default: true
  },
  align: {
    type: String,
    default: 'left'
  },
  value: {},
  defaultValue: {},
  defaultTime: {},
  rangeSeparator: {
    default: '～'
  },
  pickerOptions: {},
  // unlinkPanels: {
  //   type: Boolean,
  //   default: true
  // },
  validateEvent: {
    type: Boolean,
    default: true
  },
  isParseInputYear: {
    type: Boolean,
    default: true
  },
  // clearBoth: { // 清除currentData
  //   type: Boolean,
  //   default: false
  // },
  singleValue: { // 保留单边的值，不清空整个currentData
    type: Boolean,
    default: false
  },
  // errorTipsConfig: {
  //   type: Object,
  //   default: () => ({})
  // }
  operation: String,
  maxDate: {
    type: Date,
    default: () => new Date('2068-01-01 23:59:59')
  },
  showTime: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: 'date'
  },
  showShortcuts: {
    type: Boolean,
    default: true
  },
  cellClassName: {
    type: [Function, String]
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/props/picker.js